module.exports = __webpack_public_path__ + "img/SO.caecb2b2.svg";